import React from "react";
import "./notification-item.css";
import { LiaThumbtackSolid } from "react-icons/lia";
import StatusComponent from "../../../../ui/atoms/status/StatusComponent";
import { capitalizeAll } from "../../../../core/utils/helpers";
import moment from "moment";

const NotificationItem = ({ from, date, title, status, onAction }) => {
  return (
    <div className="notification-item" onClick={() => onAction()}>
      <div className="notification-item-row">
        <h1>{capitalizeAll(from)}</h1>
        <div className="ticks">
          <span>{moment(date).fromNow()}</span>
        </div>
      </div>
      <div className="notification-item-row">
        <p>{capitalizeAll(title)}</p>
        <div className="ticks">
          {status && (
            <StatusComponent
              type={status === "sent" ? "success" : "default"}
              title={capitalizeAll(status)}
            />
          )}
          <LiaThumbtackSolid className="icon" />
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;
